// DIESMAX v3 · tema de Shopify (Signo Studio). Lo que se mueve en la tienda:
// carrito en cajón (Cart AJAX API + Section Rendering API), página del carrito, buscador con
// resultados al escribir (búsqueda predictiva de Shopify), filtros sin recargar, vista en lista o
// cuadrícula, galería y cantidad de la ficha.
// Todo lo que viene de la tienda lo arma Shopify en el servidor (Liquid ya lo escapa); aquí solo se
// mueven nodos y se escribe con textContent. Sin innerHTML y sin librerías.
'use strict';

(() => {
  const $ = (s, d = document) => d.querySelector(s);
  const $$ = (s, d = document) => Array.from(d.querySelectorAll(s));
  const el = (tag, texto, clase) => {
    const n = document.createElement(tag);
    if (texto !== undefined && texto !== null) n.textContent = texto;
    if (clase) n.className = clase;
    return n;
  };
  let CFG = { rutas: {}, max: 5 };
  try { CFG = JSON.parse($('#dm-config').textContent); } catch (e) { /* se queda lo de arriba */ }
  const RUTAS = CFG.rutas || {};
  const MAX = Number(CFG.max) || 5;
  const RAIZ = RUTAS.raiz || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ruta = (r, def) => RUTAS[r] || `${RAIZ.replace(/\/$/, '')}/${def}`;
  const PAGINA = document.body.dataset.pagina || '';
  const pesos = (n) => `$${(Math.round(Number(n) * 100) / 100).toLocaleString('es-MX', { maximumFractionDigits: 2 })}`;
  const piezasTxt = (n) => `${n} ${n === 1 ? 'pieza' : 'piezas'}`;
  const leer = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const guardar = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } };

  // Convierte el HTML que regresa Shopify (secciones) en nodos, sin pintarlo con innerHTML
  const parsear = (html) => new DOMParser().parseFromString(html, 'text/html');
  const importar = (nodo) => document.importNode(nodo, true);

  /* ---------- Cajón del carrito ---------- */
  const SECCION_CARRITO = 'dm-carrito';
  let antesDeAbrir = null;
  const cajon = () => $('#carrito');
  const veloCarrito = () => $('[data-dm-velo-carrito]');

  function avisoCajon(texto) {
    const c = $('#carrito [data-carrito-parte="cuerpo"]');
    if (!c) return;
    const viejo = $('.cajon-aviso', c);
    if (viejo) viejo.remove();
    if (texto) c.prepend(el('p', texto, 'cajon-aviso'));
  }
  function abrirCarrito(aviso = '') {
    if (PAGINA === 'cart') {
      const c = $('[data-dm-carrito-pagina]');
      if (c) c.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    const caj = cajon();
    if (!caj) { location.href = ruta('carrito', 'cart'); return; }
    avisoCajon(aviso);
    if (caj.classList.contains('abierto')) return;
    antesDeAbrir = document.activeElement;
    veloCarrito().hidden = false;
    caj.classList.add('abierto');
    document.body.classList.add('con-cajon');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => { const x = $('.cajon-cerrar', caj); if (x) x.focus(); }, 60);
  }
  function cerrarCarrito() {
    const caj = cajon();
    if (!caj || !caj.classList.contains('abierto')) return;
    caj.classList.remove('abierto');
    veloCarrito().hidden = true;
    document.body.classList.remove('con-cajon');
    document.documentElement.style.overflow = '';
    avisoCajon('');
    if (antesDeAbrir && antesDeAbrir.focus) antesDeAbrir.focus();
  }

  // Pone en la página lo que regresó Shopify para la sección del cajón
  function pintarCarrito(html, brinca) {
    if (!html) return;
    const doc = parsear(html);
    $$('[data-carrito-parte]', doc).forEach((nuevo) => {
      const actual = $(`#carrito [data-carrito-parte="${nuevo.dataset.carritoParte}"]`);
      if (actual) actual.replaceWith(importar(nuevo));
    });
    const datos = $('#carrito [data-carrito-parte="datos"]');
    if (!datos) return;
    const n = Number(datos.dataset.n) || 0;
    $$('[data-dm-cuenta]').forEach((c) => {
      c.textContent = String(n);
      c.setAttribute('aria-label', datos.dataset.etiqueta || `${piezasTxt(n)} en el carrito`);
      if (brinca) { c.classList.remove('brinca'); void c.offsetWidth; c.classList.add('brinca'); }
    });
    document.dispatchEvent(new CustomEvent('dm:carrito', { detail: { n } }));
  }
  const seccionPagina = () => { const p = $('[data-dm-carrito-pagina]'); return p ? p.dataset.seccion : ''; };
  function pintarPagina(html) {
    const actual = $('[data-dm-carrito-pagina]');
    if (!actual || !html) return;
    const nuevo = $('[data-dm-carrito-pagina]', parsear(html));
    if (nuevo) { actual.replaceWith(importar(nuevo)); armarPaginaCarrito(); }
  }
  async function refrescarCarrito() {
    try {
      const ids = [SECCION_CARRITO, seccionPagina()].filter(Boolean);
      const r = await fetch(`${location.pathname}?sections=${encodeURIComponent(ids.join(','))}`);
      const j = await r.json();
      pintarCarrito(j[SECCION_CARRITO], true);
      if (ids[1]) pintarPagina(j[ids[1]]);
    } catch (e) { /* nada */ }
  }
  // Para el asistente: abrir el cajón y volver a pintarlo después de agregar desde el chat
  window.dmCarrito = { abrir: () => abrirCarrito(), refrescar: () => refrescarCarrito() };

  // Cuántas lleva ya de esa variante (sale del cajón que pintó Shopify)
  function enCarrito(varianteId) {
    return $$(`#carrito [data-variante="${CSS.escape(String(varianteId))}"]`)
      .reduce((s, x) => s + (Number(x.dataset.cantidad) || 0), 0);
  }

  async function agregar(forma, boton) {
    const fd = new FormData(forma);
    const id = fd.get('id');
    let q = Math.max(1, Math.floor(Number(fd.get('quantity')) || 1));
    const ya = enCarrito(id);
    if (ya >= MAX) { abrirCarrito(`En línea son máximo ${MAX} de cada pieza. Para más, pide precio por volumen por WhatsApp.`); return; }
    let aviso = '';
    if (ya + q > MAX) { q = MAX - ya; aviso = `Llegaste al máximo de ${MAX} de esta pieza en línea. Para más, pide precio por volumen por WhatsApp.`; }
    fd.set('quantity', String(q));
    fd.append('sections', SECCION_CARRITO);
    fd.append('sections_url', location.pathname);
    if (boton) boton.disabled = true;
    try {
      const r = await fetch(`${ruta('agregar', 'cart/add')}.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      });
      const j = await r.json();
      if (!r.ok || j.status) {
        abrirCarrito(j.description || j.message || 'No se pudo agregar. Intenta otra vez o pide por WhatsApp.');
        return;
      }
      if (j.sections) pintarCarrito(j.sections[SECCION_CARRITO], true); else await refrescarCarrito();
      if (boton) { boton.classList.add('listo'); setTimeout(() => boton.classList.remove('listo'), 1200); }
      abrirCarrito(aviso);
    } catch (e) {
      forma.submit(); // si algo falla, que lo haga Shopify como formulario normal
    } finally {
      if (boton) boton.disabled = false;
    }
  }

  async function cambiarLinea(llave, cantidad, etiqueta = '') {
    const q = Math.max(0, Math.min(MAX, Math.floor(Number(cantidad) || 0)));
    const pag = $('[data-dm-carrito-pagina]');
    const ids = [SECCION_CARRITO, seccionPagina()].filter(Boolean);
    if (pag) pag.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(`${ruta('cambiar', 'cart/change')}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: llave, quantity: q, sections: ids, sections_url: location.pathname }),
      });
      const j = await r.json();
      if (!r.ok || j.status) { avisoCajon(j.description || j.message || 'No se pudo cambiar la cantidad.'); await refrescarCarrito(); return; }
      pintarCarrito(j.sections && j.sections[SECCION_CARRITO]);
      if (ids[1]) pintarPagina(j.sections && j.sections[ids[1]]);
      // Regresa el foco a la misma línea (o al cerrar si ya no está)
      const donde = PAGINA === 'cart' ? $('[data-dm-carrito-pagina]') : $('#carrito');
      const mismos = donde ? $$(`[data-dm-linea="${CSS.escape(llave)}"][data-dm-cant]`, donde) : [];
      const sigue = mismos.find((x) => !x.disabled && etiqueta && x.getAttribute('aria-label') === etiqueta) || mismos.find((x) => !x.disabled);
      if (sigue && !sigue.disabled) sigue.focus();
      else if (PAGINA !== 'cart') { const x = $('#carrito .cajon-cerrar'); if (x) x.focus(); }
    } catch (e) {
      location.href = ruta('carrito', 'cart');
    } finally {
      const p2 = $('[data-dm-carrito-pagina]');
      if (p2) p2.removeAttribute('aria-busy');
    }
  }

  // Página /cart: envío estimado según cómo lo recibe (solo informativo; se elige al pagar)
  const LL_ENTREGA = 'diesmax-v3-entrega';
  function armarPaginaCarrito() {
    const res = $('[data-dm-resumen]');
    if (!res) return;
    const sub = Number(res.dataset.subtotal) / 100 || 0;
    const radios = $$('input[name="dm-entrega"]', res);
    const pref = leer(LL_ENTREGA);
    const elegible = radios.find((r) => r.value === pref && !r.disabled);
    if (elegible) elegible.checked = true;
    const pintar = () => {
      const r = radios.find((x) => x.checked) || radios.find((x) => !x.disabled);
      const env = r ? Number(r.dataset.envio) || 0 : 0;
      const e = $('[data-dm-envio]', res);
      const t = $('[data-dm-total]', res);
      if (e) e.textContent = env ? pesos(env) : 'Gratis';
      if (t) t.textContent = pesos(sub + env);
    };
    radios.forEach((r) => r.addEventListener('change', () => { guardar(LL_ENTREGA, r.value); pintar(); }));
    pintar();
  }

  function armarCarrito() {
    const caj = cajon();
    const velo = veloCarrito();
    if (caj && velo) {
      velo.addEventListener('click', cerrarCarrito);
      caj.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { cerrarCarrito(); return; }
        if (e.key === 'Tab') { // el foco se queda dentro del cajón
          const f = $$('a[href],button:not([disabled]),input:not([disabled])', caj).filter((x) => x.offsetParent !== null);
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
    }
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-dm-cerrar-carrito]')) { cerrarCarrito(); return; }
      const abrir = e.target.closest('[data-dm-abrir-carrito]');
      if (abrir && !e.metaKey && !e.ctrlKey) { e.preventDefault(); abrirCarrito(); return; }
      // − / + / Quitar en el cajón y en la página del carrito
      const b = e.target.closest('[data-dm-linea][data-dm-cant]');
      if (b && (b.closest('#carrito') || b.closest('[data-dm-carrito-pagina]'))) {
        e.preventDefault();
        if (!b.disabled) cambiarLinea(b.dataset.dmLinea, b.dataset.dmCant, b.getAttribute('aria-label') || '');
      }
    });
    document.addEventListener('change', (e) => {
      const i = e.target.closest('input[data-dm-input]');
      if (i) cambiarLinea(i.dataset.dmLinea, parseInt(i.value, 10) || 0);
    });
    // "Agregar" en tarjetas y en la ficha (son formularios /cart/add: sin JS también funcionan)
    document.addEventListener('submit', (e) => {
      const f = e.target.closest('form[data-dm-agregar]');
      if (!f) return;
      e.preventDefault();
      agregar(f, e.submitter || $('button[type=submit]', f));
    });
    armarPaginaCarrito();
  }

  /* ---------- Respaldo del buscador: piezas de /products.json (número de parte, equivalencias, nombre) ---------- */
  let piezasLocales = null;
  const normal = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const compacta = (s) => normal(s).replace(/[^a-z0-9]/g, '');
  async function cargarPiezas() {
    if (piezasLocales) return piezasLocales;
    try {
      const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const j = await (await fetch(`${raiz}products.json?limit=250`, { headers: { Accept: 'application/json' } })).json();
      piezasLocales = (j.products || []).map((p) => {
        const v = (p.variants || [])[0] || {};
        const cuerpo = new DOMParser().parseFromString(p.body_html || '', 'text/html').body.textContent || '';
        return { url: `${raiz}products/${p.handle}`, n: p.title, sku: v.sku || '', precio: Number(v.price || 0), foto: (p.images && p.images[0] && p.images[0].src) || '',
          texto: normal([p.title, v.sku, p.vendor, p.product_type, (p.tags || []).join ? p.tags.join(' ') : p.tags, cuerpo].join(' ')), compacto: compacta([v.sku, cuerpo].join(' ')) };
      });
    } catch (e) { piezasLocales = []; }
    return piezasLocales;
  }
  async function buscarLocal(q) {
    const ps = await cargarPiezas();
    const c = compacta(q);
    const palabras = normal(q).split(/\s+/).filter((w) => w.length > 1);
    if (!palabras.length) return [];
    return ps.filter((p) => (c.length >= 3 && p.compacto.includes(c)) || palabras.every((w) => p.texto.includes(w))).slice(0, 5);
  }
  function pintarLocales(ps, q) {
    const nodos = ps.map((p) => {
      const a = el('a'); a.href = p.url; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
      if (p.foto) { const i = new Image(); i.src = `${p.foto}${p.foto.includes('?') ? '&' : '?'}width=96`; i.alt = ''; i.width = 48; i.height = 48; a.append(i); }
      const s = el('span'); s.append(el('span', p.sku || p.n, 'np'), el('span', p.n, 's-n')); a.append(s);
      a.append(el('b', `$${p.precio.toLocaleString('es-MX', { maximumFractionDigits: 2 })}`));
      return a;
    });
    const todo = el('a', `Ver resultados para “${q}”`, 's-todo');
    todo.href = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}search?type=product&q=${encodeURIComponent(q)}`;
    nodos.push(todo);
    return nodos;
  }

  /* ---------- Buscador con resultados al escribir (búsqueda predictiva de Shopify) ---------- */
  const CAMPOS = 'title,variants.sku,vendor,product_type,tag,body';
  function armarBuscador(forma) {
    const caja = $('input[type=search]', forma);
    const lista = $('.sugerencias', forma);
    if (!caja || !lista) return;
    let sel = -1;
    const ligas = () => $$('a', lista);
    const mostrar = (si) => { lista.hidden = !si; caja.setAttribute('aria-expanded', String(si)); if (!si) sel = -1; };
    let pedido = 0;
    let espera = null;
    const pintar = async () => {
      const v = caja.value.trim();
      if (v.length < 2) { lista.replaceChildren(); mostrar(false); return; }
      const n = ++pedido;
      const u = new URL(ruta('sugerencias', 'search/suggest'), location.origin);
      u.searchParams.set('q', v.slice(0, 60));
      u.searchParams.set('resources[type]', 'product');
      u.searchParams.set('resources[limit]', '10');
      u.searchParams.set('resources[limit_scope]', 'each');
      u.searchParams.set('resources[options][unavailable_products]', 'last');
      u.searchParams.set('resources[options][fields]', CAMPOS);
      u.searchParams.set('section_id', 'dm-predictiva');
      try {
        const r = await fetch(u, { headers: { Accept: 'text/html' } });
        if (!r.ok) throw new Error(String(r.status));
        const doc = parsear(await r.text());
        if (n !== pedido) return; // ya escribió otra cosa
        const res = $('#dm-predictiva-res', doc);
        const hayPiezas = !!res && !!$('a[role=option]', res);
        // Respaldo: la búsqueda rápida de Shopify a veces regresa vacío; entonces buscamos en las piezas de la tienda
        const locales = hayPiezas ? [] : await buscarLocal(v);
        if (n !== pedido) return;
        if (locales.length) lista.replaceChildren(...pintarLocales(locales, v));
        else lista.replaceChildren(...(res ? Array.from(res.childNodes).map(importar) : []));
        sel = -1;
        mostrar(lista.childElementCount > 0);
      } catch (e) {
        mostrar(false);
      }
    };
    caja.addEventListener('input', () => { clearTimeout(espera); espera = setTimeout(pintar, 160); });
    caja.addEventListener('focus', () => { if (caja.value.trim().length >= 2 && lista.childElementCount) mostrar(true); });
    caja.addEventListener('keydown', (e) => {
      const ls = ligas();
      if (e.key === 'Escape') { mostrar(false); return; }
      if (lista.hidden || !ls.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + ls.length) % ls.length;
        ls.forEach((a, i) => a.setAttribute('aria-selected', String(i === sel)));
        ls[sel].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && sel >= 0) { e.preventDefault(); ls[sel].click(); }
    });
    forma.addEventListener('focusout', () => setTimeout(() => { if (!forma.contains(document.activeElement)) mostrar(false); }, 150));
    forma.addEventListener('submit', async (e) => {
      const v = caja.value.trim();
      if (!v) { e.preventDefault(); caja.focus(); return; }
      if (forma.dataset.directo === '1') return;
      // Si escribió un número de parte (aunque sea sin guion o con espacios: GP11, gp 11, t3030), va directo a la pieza
      e.preventDefault();
      const c = compacta(v);
      const ps = c.length >= 3 ? await cargarPiezas() : [];
      const exactas = ps.filter((p) => compacta(p.sku) === c);
      const parciales = exactas.length ? exactas : ps.filter((p) => p.sku && compacta(p.sku).startsWith(c) && c.length >= 3);
      if (parciales.length === 1) { location.href = parciales[0].url; return; }
      forma.dataset.directo = '1';
      forma.submit();
    });
    document.addEventListener('click', (e) => { if (!forma.contains(e.target)) mostrar(false); });
  }

  /* ---------- Catálogo: filtros sin recargar, orden y vista ---------- */
  const LL_VISTA = 'diesmax-v3-vista';
  function armarCatalogo() {
    const raiz = $('[data-dm-catalogo]');
    if (!raiz) return;
    let vista = leer(LL_VISTA) === 'lista' ? 'lista' : 'rejilla';
    const ponerVista = () => {
      $$('[data-dm-rejilla]', raiz).forEach((r) => r.classList.toggle('es-lista', vista === 'lista'));
      $$('[data-vista]', raiz).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vista === vista)));
    };
    ponerVista();

    // Filtros abiertos en compu, cerrados en celular (se abren con "Filtrar")
    const caja = $('[data-dm-filtros-caja]', raiz);
    const mq = window.matchMedia('(max-width: 900px)');
    const ajustar = () => { if (caja) caja.open = !mq.matches; };
    ajustar();
    if (mq.addEventListener) mq.addEventListener('change', ajustar);

    let pedido = 0;
    async function cargar(url) {
      const n = ++pedido;
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', raiz.dataset.seccion);
      raiz.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch(u, { headers: { Accept: 'text/html' } });
        if (!r.ok) throw new Error(String(r.status));
        const doc = parsear(await r.text());
        if (n !== pedido) return;
        // Para regresar el foco a la misma casilla después de cambiar el formulario
        const foco = document.activeElement;
        const llave = (i) => `${i.name || ''}|${i.value}|${i.dataset.gte || ''}|${i.dataset.lte || ''}`;
        const llaveFoco = foco && foco.closest && foco.closest('[data-dm-parte="filtros"]') && foco.matches('input') ? llave(foco) : '';
        $$('[data-dm-parte]', doc).forEach((nuevo) => {
          const actual = $(`[data-dm-parte="${nuevo.dataset.dmParte}"]`, raiz);
          if (actual) actual.replaceWith(importar(nuevo));
        });
        ponerVista();
        if (llaveFoco) {
          const otra = $$('[data-dm-parte="filtros"] input', raiz).find((i) => llave(i) === llaveFoco);
          if (otra) otra.focus();
        }
        u.searchParams.delete('section_id');
        try { history.replaceState(null, '', u.pathname + u.search); } catch (e) { /* nada */ }
      } catch (e) {
        u.searchParams.delete('section_id');
        location.href = u.toString();
      } finally {
        raiz.removeAttribute('aria-busy');
      }
    }
    // Arma la dirección con los filtros (filter.p.vendor=…, filter.v.price.gte=…, sort_by=…)
    function urlDeFiltros() {
      const forma = $('[data-dm-filtros]', raiz);
      const orden = $('[data-dm-orden]', raiz);
      if (!forma) {
        const u = new URL(location.href);
        if (orden) u.searchParams.set('sort_by', orden.value);
        u.searchParams.delete('page');
        return u.pathname + u.search;
      }
      const accion = new URL(forma.getAttribute('action'), location.origin);
      // Se conserva lo que ya trae la dirección de la colección (p. ej. /collections/vendors?q=Gonher)
      const p = new URLSearchParams(accion.search);
      new FormData(forma).forEach((v, k) => { if (v !== '') p.append(k, v); });
      const precio = $('[data-dm-precio]:checked', forma);
      if (precio) {
        if (precio.dataset.gte) p.set(precio.dataset.gteParam, precio.dataset.gte);
        if (precio.dataset.lte) p.set(precio.dataset.lteParam, precio.dataset.lte);
      }
      if (orden && !p.has('sort_by')) p.set('sort_by', orden.value);
      return `${accion.pathname}?${p.toString()}`;
    }

    raiz.addEventListener('change', (e) => {
      const i = e.target;
      if (i.matches('[data-dm-precio]') && i.checked) {
        $$('[data-dm-precio]', raiz).forEach((x) => { if (x !== i) x.checked = false; });
      }
      if (i.closest('[data-dm-filtros]') || i.matches('[data-dm-orden]')) cargar(urlDeFiltros());
    });
    raiz.addEventListener('submit', (e) => {
      if (!e.target.matches('[data-dm-filtros]')) return;
      e.preventDefault();
      cargar(urlDeFiltros());
    });
    raiz.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-dm-ajax]');
      if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); cargar(a.href); return; }
      const b = e.target.closest('[data-vista]');
      if (b) {
        vista = b.dataset.vista === 'lista' ? 'lista' : 'rejilla';
        guardar(LL_VISTA, vista);
        ponerVista();
      }
    });
  }

  /* ---------- Ficha: galería y cantidad ---------- */
  function armarFicha() {
    const raiz = $('[data-dm-producto]');
    if (!raiz) return;
    const gal = $('[data-dm-galeria]', raiz);
    const grande = gal && $('.gal-grande img', gal);
    const minis = gal ? $$('.gal-mini', gal) : [];
    if (grande && minis.length > 1) {
      minis.forEach((b, i) => b.addEventListener('click', () => {
        grande.removeAttribute('fetchpriority');
        grande.removeAttribute('srcset');
        grande.src = b.dataset.src;
        grande.srcset = b.dataset.srcset;
        grande.alt = `${gal.dataset.alt || ''}${i ? `, foto ${i + 1}` : ''}`;
        minis.forEach((x) => x.removeAttribute('aria-current'));
        b.setAttribute('aria-current', 'true');
      }));
    }
    const f = $('form.comprar', raiz);
    const sel = f && $('[data-cant]', f);
    const menos = f && $('[data-menos]', f);
    const mas = f && $('[data-mas]', f);
    if (sel && menos && mas) {
      const tope = sel.options.length || MAX;
      const pinta = () => { const v = Number(sel.value); menos.disabled = v <= 1; mas.disabled = v >= tope; };
      menos.addEventListener('click', () => { sel.value = String(Math.max(1, Number(sel.value) - 1)); pinta(); });
      mas.addEventListener('click', () => { sel.value = String(Math.min(tope, Number(sel.value) + 1)); pinta(); });
      sel.addEventListener('change', pinta);
      pinta();
    }
  }

  const iniciar = () => {
    armarCarrito();
    $$('form[data-dm-buscador]').forEach(armarBuscador);
    armarCatalogo();
    armarFicha();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
